import { staticPages } from '@liefersoft/pos-ui-core'
import { jwtGetRoles } from '../../../../helper/jwt'

export const getStaticPageIds = () => {
	return staticPages.reduce((acc, page) => {
		if (page.static) {
			acc.push(page.id)
		}
		return acc
	}, [])
}

const staticPageIds = new Set(staticPages.map(p => p.id))

export const getPagesFromRoles = (accessToken) => {
	const roles = jwtGetRoles(accessToken) || []
	const pages = roles
		.filter(role => role.endsWith('_READ'))
		.map(role => role.replace('_READ', ''))
		.filter(pageId => staticPageIds.has(pageId))
	const staticIds = getStaticPageIds()
	return [...new Set([...pages, ...staticIds])]
}
